import angular from 'angular'

export default angular
    .module('outputManage.billManage.openedInvoice', [])



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/openedInvoice/openedInvoiceModule.js